import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/it/guide')({
  component: Outlet,
})
